import { Section, Container, Grid, ProgramCard, ProgramIcon, ProgramTitle, ProgramDescription } from './styles';
import { FaGraduationCap, FaLeaf, FaUsers, FaUserFriends } from 'react-icons/fa';

const programs = [
  {
    icon: <FaGraduationCap />,
    title: "Education aux droits de l'homme",
    description: "Formation à la démocratie et à la gouvernance locale pour un avenir plus équitable"
  },
  {
    icon: <FaLeaf />,
    title: "Développement durable",
    description: "Promotion de la santé communautaire et des pratiques durables"
  },
  {
    icon: <FaUsers />,
    title: "Appuis technique et organisationnel",
    description: "Soutien aux OCB et ETD pour renforcer les capacités locales"
  },
  {
    icon: <FaUserFriends />,
    title: "Jeunes citoyens et genre",
    description: "Promotion de l'égalité et de l'engagement citoyen des jeunes"
  }
];

const ProgramPreview = () => {
  return (
    <Section>
      <Container>
        <h2>Nos Programmes</h2>
        <Grid>
          {programs.map((program, index) => (
            <ProgramCard key={index}>
              <ProgramIcon>{program.icon}</ProgramIcon>
              <ProgramTitle>{program.title}</ProgramTitle>
              <ProgramDescription>{program.description}</ProgramDescription>
            </ProgramCard>
          ))}
        </Grid>
      </Container>
    </Section>
  );
};

export default ProgramPreview;